export default {
	title: 'Konspirative Wohnungen Leipzig',
	gsmaterials: {
		app: {
			scrollTop: {
				offset: 250,
				size: 'sm',
				icon: 'i-mdi-chevron-up',
				class: 'z-20 bg-primary-100 hover:bg-accent transition-colors duration-300 ease-in-out'
			}
		}
	}
}
